import React from 'react';
import { Checkbox } from '@material-ui/core';
import Check from '../../../../assets/svg/check';
import Block from '../../../../assets/svg/block';
import { colors } from 'kangarootime-ui';
import './PhotoApproval.css';
import ActionButton from './ActionButton';
import useHover from '../../../../hooks/useHover';

const PhotoApproval = ({ photo, isSelected, ...props }) => {
  const [isHovered, bind] = useHover();
  const { image, first_name: firstName, last_name: lastName, group_image_id: groupImageId, note, child_id: childId } = photo;

  return (
    <div
      {...bind}
      className='photoApprovalPhoto'
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className='checkboxContainer'>
        <Checkbox
          checked={isSelected}
          style={{ color: colors.brand_3 }}
          onChange={() => props.handleSelection(photo)}
        />
      </div>
      { isHovered
        ? <div className='photoApprovalNoteContainer' onClick={() => props.expandPhoto(photo)}>
          <div style={{ margin: 8 }}>
            <label className='noteContainerPrimaryText'>{firstName} {lastName}</label>
            <div style={{ height: 48, overflow: 'auto' }}>
              <p className='noteContainerSecondaryText'>{note.description ? note.description : ''}</p>
            </div>
            <div className='photoApprovalActions'>
              <span className='noteContainerPrimaryText'>Approve?</span>
              <ActionButton
                icon={<Check fill={colors.success} />}
                onClick={event => {
                  event.stopPropagation();
                  props.approvePhoto([{
                    photoId: groupImageId,
                    childId
                  }]);
                }}
              />
              <ActionButton
                icon={<Block fill={colors.danger} />}
                onClick={event => {
                  event.stopPropagation();
                  props.rejectPhoto([{
                    photoId: groupImageId,
                    childId
                  }]);
                }}
              />
            </div>
          </div>
        </div> : null
      }
    </div>
  );
};

export default PhotoApproval;
